/**
 * 中文 - 繁体
 *
 */

export default {
  curlan:'zh-TW',
  common: {
    sotck_hk: '港股',
    sotck_us: '美股',
    sotck_A: 'A股',
    free: '免費',
    tips1: '保存失敗',
    unopen: '未開戶',
  },
  tuyere: {
    title: '熱門股單',
    nodata: '暫無數據',
    down_refresh: {
      contentdown: '下拉刷新',
      contentover: '釋放刷新',
      contentrefresh: '加載中...',
      contentsuccess: '刷新成功',
      contenterror: '刷新失敗',
    },
    head: {
      txt_1: '股票名稱',
      txt_2: '當前價',
      txt_3: '年初至今漲跌幅'
    },
    concept: {
      txt_1: '收起',
      txt_2: '還有{num}家公司，點擊查看全部'
    },
    foot_1: '風險提示：以上數據來自第三方數據源，僅供參考，不構成投資建議。',
    foot_2: '行情資訊服務由富元犇犇提供',
    foot_3: '免責聲明'
  },
  my_market: {
    title: '我的行情',
    active: '當前權限',
    buy: '購買',
    renew: '續期',
    lv1: {
      txt_1: '延時行情',
      txt_2: '實時行情手工刷新/無盤口數據',
      txt_2_1: '行情數據（報價、分時、K線等）延時15分鐘，無經紀席位、盤口、成交明細。',
      txt_3: '無盤口數據',
      txt_4: '免費',
      txt_5: 'LV1基礎行情'
    },
    lv2: {
      txt_1: 'LV2即時行情',
      txt_2: '實時更新/10檔盤口/10檔經紀隊列',
      txt_3: '實時行情實時更新/提供1檔買賣盤口',
      txt_5: '剩餘{day}天',
      txt_8: '實時',
      txt_9: '實時行情/提供5檔買賣盤口',
      txt_11: '{money}港幣/月',
      txt_12: '會員贈送',
    },
    warn_title:'溫馨提示:',
    warn_desc:`1、普通會員將會免費贈送1次30天的L2行情；<br/>
    2、白銀、黃金、鉑金、鑽石會員，會員存續期<br/>將一直免費贈送L2行情；`
  },
  intro_quota:{
    title: '我的行情',
    text_1:'自動更新',
    text_2:'買賣盤5檔',
    text_3:'即時自動更新',
    text_4:'免費',
    text_5:'手工刷新',
    text_6:'買賣10檔',
    text_7:'10-40檔',
    text_8:'20隻之外延時',
    text_10:'長期有效',
    text_11:'根據購買時長',
    text_12:'13HKD/月',
    text_13:'200HKD/月',
    text_14:'400HKD/月(含PC)',
    text_15:'2.99USD/月',
    text_16:'延時15分鐘',
    text_17:'延時更新',
    text_18:'*註：BMP行情已下線。',
    hk:{
      text_1:'港股LV2行情',
      text_2:`實時更新/10檔盤口/<br/>
      10檔經紀隊列`,
      text_3:'港股行情對比',
      table_txt1:'延時行情',
      table_txt2:'實時LV2',
      table_col1_txt1:'實時數據',
      table_col1_txt2:'推送',
      table_col1_txt3:'盤口數據',
      table_col1_txt4:'逐筆成交',
      table_col1_txt5:'經紀席位',
      table_col1_txt6:'行情清單',
      table_col1_txt7:'國內定價',
      table_col1_txt8:'海外定價',
      table_col1_txt9:'app+pc互通',
      table_col1_txt10:'到期日',
      text_4:'逐筆明細',
      text_5:'精確反映盤中交易變動，洞悉資金流入流出意圖',
      text_6:'10檔買賣盤委託',
      text_7:'把握股價的支撐阻力位，精準下單提高成交率',
      text_8:'買賣盤經紀商',
      text_9:'看清機構控盤行為及掛單量',

    },
    us:{
      text_1:'美股LV2行情',
      text_2:`實時行情/實時更新/<br/>
      提供1檔買賣盤口`,
      text_3:'美股行情對比',
      table_txt1:'實時LV1',
      table_txt2:'實時LV2',
      table_col1_txt1:'實時數據',
      table_col1_txt2:'即時推送',
      table_col1_txt3:'盤口數據',
      table_col1_txt4:'逐筆成交',
      table_col1_txt5:'經紀席位',
      table_col1_txt6:'行情清單',
      table_col1_txt7:'定      價',
      table_col1_txt8:'app+pc互通',
      table_col1_txt9:'到期日',
      text_4:'逐筆明細',
      text_5:'精確反映盤中交易變動，洞悉資金流入流出意圖',
      text_6:'1檔買賣盤委託',
      text_7:'把握股價的支撐阻力位，精準下單提高成交率',
      text_8:'買賣盤經紀商',
      text_9:'看清機構控盤行為及掛單量',
    },
    cn:{
      text_1:'A股LV1行情',
      text_2:'實時行情/提供5檔買賣盤口',
      text_3:'A股行情說明',
      table_txt1:'延時LV1',
      table_col1_txt1:'實時數據',
      table_col1_txt2:'即時推送',
      table_col1_txt3:'盤口數據',
      table_col1_txt4:'逐筆成交',
      table_col1_txt5:'經紀席位',
      table_col1_txt6:'行情清單',
      table_col1_txt7:'定      價',
      table_col1_txt8:'app+pc互通',
      text_4:'逐筆明細',
      text_5:'精確反映盤中交易變動，洞悉資金流入流出意圖',
      text_6:'5檔買賣盤委託',
      text_7:'把握股價的支撐阻力位，精準下單提高成交率',
      text_8:'買賣盤經紀商',
      text_9:'看清機構控盤行為及掛單量',
    },

  },
  how_to_invest_old: {
    title: '為什麼投資港美股',
    name1: '投資全球頂尖港美上市公司',
    desc1: {
      text_1: '市場透明',
      text_2: '港美股市制度規範透明',
      text_3: '投資者權益保障更完善',
    },
    desc2: {
      text_1: 'T+0交易',
      text_2: '日內買賣，交易靈活',
    },
    desc3: {
      text_1: "無資金門檻",
      text_2: '無需50億資金門檻',
    },
    desc4: {
      text_1: '標的豐富',
      text_2: '股票、ETF、基金及衍生品'
    },
    name2: '港股大新多重優勢',
    advantage1: {
      text_1: '認購0門檻',
      text_2: '無帳户持倉市值要求',
      text_3: '存入新股預繳金即可打新',
    },
    advantage2: {
      text_1: '認購靈活',
      text_2: '可融資可現金申購',
      text_3: '靈活搞定港股打新',
    },
    advantage3: {
      text_1: '融資利率低',
      text_2: '可融資認購',
      text_3: '年利率低至1.88%',
      text_4: '最高20倍融資槓桿助力打新'
    },
    advantage4: {
      text_1: '賺錢效應',
      text_2: '截至2021年1月至11月3日',
      text_3: '默認每隻新股都認購',
      text_4: '累計權益收益率約81%'
    },
    advantage5: {
      text_1: '暗盤交易',
      text_2: '可於新股上市前一個交易日',
      text_3: '收盤後暗盤時段買賣該股票'
    },
    advantage6: {
      text_1: '獨角獸紅利',
      text_2: '獨角獸企業上市後受到',
      text_3: '資本市場熱捧',
      text_4: '如：快手-W首日一手約賺1.9萬港幣'
    },
    phone: '更多問題，請致電官方客服：400-688-3187'
  },
  how_to_invest:{
    title:'為什麼投資港美股？',
    title1:'投資全球頂尖港美上市公司',
    title2:'時間會凸顯好公司的價值，就像巴菲特一樣，持有並留住好公司。',
    listTitle:'完善的市場和監管體系',
    ul:{
      li1:{
        t1:'交易市場透明化',
        t2:'港美股市場制度規範透明，投資者權益保障更完善'
      },
      li2:{
        t1:'T+0 交易',
        t2:'可日內買賣，交易更靈活'
      },
      li3:{
        t1:'豐富的投資品種',
        t2:'股票、ETF、基金及衍生品'
      },
      li4:{
        t1:'融資方便，可賣空交易',
        t2:'融資門檻低，可結合衍生品實現做空'
      }
    }
  },
  account_security_old: {
    title: '關於賬户安全',
    title1: '遵循監管合規經營',
    title2: '讓您放心完成每筆交易',
    content1: {
      desc1: {
        text_1: '持牌券商',
        text_2: '香港聯合交易所及結算所參與者',
        text_3: '持牌券商(中央編號：AAW177)',
      },
      desc2: {
        text_1: '獨立託管',
        text_2: '客户資金獨立託管在中國銀行(香港)',
        text_3: '客户證券資產託管在中央結算機構',
      },
      desc3: {
        text_1: '品牌積澱',
        text_2: '1989年創立於中國香港',
        text_3: '擁有超過32年的行業積澱',
      },
      desc4: {
        text_1: '數據加密',
        text_2: '採用銀行級高度加密技術保障',
        text_3: '分佈式數據中心 確保客户資產及信息安全',
      },
      desc5: {
        text_1: '保險保障',
        text_2: '港股受香港投資者賠償基金(ICF)保護',
        text_3: '提供50萬港幣保障',
      },
    },
    title3: '榮獲多項業界獎項',
    content3: {
      desc1: {
        text_1: '最佳互聯網創新券商',
        text_2: '智通財經頒發'
      },
      desc2: {
        text_1: '優秀港資券商APP',
        text_2: '證券時報 券商中國 頒發'
      },
      desc3: {
        text_1: '創新內地市場服務信息商',
        text_2: '港交所頒發'
      },
      desc4: {
        text_1: '最佳綜合服務獎',
        text_2: '鳳凰網財經頒發'
      }
    },
    phone: '更多問題，請致電官方客服：400-688-3187'
  },
  account_security:{
    title:'帳戶安全保障',
    title1:'我們視客戶的資金安全高於一切',
    ul:{
      li1:{
        t1:'持牌券商',
        t2:'Meta Stock PTY LTD是注册在澳大利亞的證券公司，由澳大利亞證券和投資委員會（ASIC）許可和監管，商業登記號：17656191847。',
        t3:'元宇證券是香港證監會持牌法團（持牌編號：AAW177），持有1/4/5/9號業務牌照資質，正在申請香港2/6/7號牌照。 集團正在獲取澳大利亞AFSL Licence、新加坡CMS license以及美國SEC Broker-Dealer。'
      },
      li2:{
        t1:'客戶資產合規託管',
        t2:'客戶資產以託管形式持有和保管，不接受任何協力廠商出入金，每交易日進行資產計算、確認和對賬。',
        t3:'客戶資產以託管形式持有和保管，不接受任何協力廠商出入金，每交易日進行資產計算、確認和對賬。'
      },
      li3:{
        t1:'客戶帳戶嚴格監管',
        t2:'客戶帳戶定期嚴格審查及內外稽核，均遵循當地監管機构要求嚴格監管。',
        t3:'客戶帳戶定期嚴格審查及內外稽核，均遵循當地監管機构要求嚴格監管。'
      },
    }
  },
  why_choose_us_old: {
    title: '為何選擇我們',
    title1: '開户省心，交易安心',
    content1: {
      desc1: {
        text_1: '交易放心',
        text_2: '香港證監會監管的持牌券商',
        text_3: '(中央編號：AAW177)',
      },
      desc2: {
        text_1: '資金安心',
        text_2: '資金/資產第三方獨立託管 嚴格監管保障',
      },
      desc3: {
        text_1: '開户省心',
        text_2: '線上2分鐘極速開户 一個賬户 投資全球',
      },
      desc4: {
        text_1: '入金順心',
        text_2: '支持FPS/e-DDA/銀證 多種極速入金方式',
      },
      desc5: {
        text_1: '福利動心',
        text_2: '開户即送優質股 更多福利無上限',
      },
      desc6: {
        text_1: '服務貼心',
        text_2: '客户滿意為導向 專業答疑 貼心服務',
      }
    },
    phone: '更多問題，請致電官方客服：400-688-3187'
  },
  why_choose_us: {
    title:'為什麼選擇我們？',
    title_intro:'元宇證券，盡享優質投資服務',
    ul:{
      li1:{
        t1:'一個帳戶，投資全球',
        t2:'一站式港/美股、滬/深股通交易平臺，讓您投資更便捷更高效',
      },
      li2:{
        t1:'豐富投資選擇',
        t2:'美股正股、港股正股、A股正股、ETF、REITs、港股窩輪權證，更多的金融產品即將上線',
      },
      li3:{
        t1:'元宇研究院',
        t2:'元宇研究院',
      },
      li4:{
        t1:'3V1尊享服務',
        t2:'3V1 VIP服務，為您的投資之路保駕護航',
      }
    },
    concat:'更多问题请联系客服'
  },
  how_the_gold_old: {
    title: '如何存入資金',
    title1: '存入資金，只需三步',
    content1: {
      desc1: {
        text_1: '準備銀行卡 選擇入金方式',
        text_2: '支持FPS/e-DDA/銀證等多種入金方式',
      },
      desc2: {
        text_1: '匯款至證券賬户',
        text_2: '提交審核',
      },
      desc3: {
        text_1: '查看收款信息',
        text_2: '最快5分鐘到賬',
      }
    },
    phone1: '更多詳情，請在APP中依次點擊「消息」-「幫助中心」查看',
    phone2: '或致電官方客服 400-688-3187'
  },
  how_the_gold:{
    title:'如何存入資金',
    title1:'入金快速到賬',
    title2:'存入資金，只需三步',
    ul:{
      li1:{
        t1:'查看收款銀行資訊',
        t2:'打開App，根據存款指引，查看收款銀行的具體資訊。',
      },
      li2:{
        t1:'匯款至收款銀行帳戶',
        t2:'在App中提交轉帳資訊供系統稽核',
      },
      li3:{
        t1:'查看收款資訊',
        t2:'最快5分鐘到賬',
      },
    },
  },
  introduction_hk: {
    title: '港股入門',
    title1: '挖掘股票市場價值窪',
    content1: {
      text_1: '港股',
      text_2: '，是指',
      text_3: '在香港聯合交易所上市的股票',
      text_4: '。香港的股票市場比內地的成熟、理性，對世界的行情反映靈敏。通常，同一家公司的股票在港股市場估值較低，價格會比A股更便宜一些，所以港股歷來被稱為“價值窪地”。'
    },
    title2: '港股的市場結構',
    content2: {
      text_1: '香港上市公司來源於全球26個不同的國家和地區，香港交易所的股票市場分為主闆和創業闆，主闆上市比創業闆嚴格很多。',
      text_2: '港股市場主要的三類股票有：',
      text_3: '藍籌股、紅籌股和國企股',
      text_4: '藍籌股',
      text_5: '這類股份的普遍特性是具有行業代錶性、流通量高、財務狀況良好、盈利穩定及派息固定。(對應的為恆生指數HSI)',
      text_6: '紅籌股',
      text_7: '是指那些註冊地在海外但在聯交所上市，由中資企業直接控制或持有三成半股權以上的上市公司股份。(對應指數為紅籌指數HSCCI)',
      text_8: '國企股',
      text_9: '指那些獲中國證監會批核到香港上市的中國大陸的國有企業。它亦可稱為 H 股，意指註冊地在中國大陸，在聯交所上市。(對應的指數為恆生國企指數HSCEI)',
      text_10: '區分紅籌和國企股的標準在於註冊地，在海外註冊的就是紅籌股，在內地註冊的自然是國企股。'
    },
    title3: '港股指數介紹',
    content3: {
      desc1: '恆生指數',
      text_1: '也是通常所說的',
      text_2: '大盤指數',
      text_3: '是以香港股票市場中的50家上市股票為成份股樣本，以其發行量為權數的加權平均股價指數，是反映香港股市價幅動趨勢最有影響的一種股價指數。',
      desc2: '恆生中國企業指數',
      text_4: '反映了在香港交易所上市的H股中較大型股的錶現，與恆生指數不同，國企指數成份股的數目並沒有限制，但必須為',
      text_5: '市值最大，且在恆生綜合指數成份股內的H股',
      desc3: '紅籌指數',
      text_6: '主要由',
      text_7: '25只市值較大，交易活躍，具有行業代錶性的紅籌股',
      text_8: '組成。分佈的行業主要包括石油化工、房地產、港口運輸、汽車、科技及綜合類等。'
    },
    title4: '港股和A股的不同',
    content4: {
      desc1: '交易時間不同',
      text_1: 'A股的交易時間是工作日上午9:00-11:30，下午1:00到3:00；港股的交易時間比A股更長，上午從',
      text_2: '9:00-12:00',
      text_3: '，下午',
      text_4: '從1:00-4:00',
      text_5: '。算下來港股每天的交易時間比A股長一個半小時。',
      desc2: '交易與交收機制不同',
      text_6: 'A股實行T+1交易，也就是說當天買入的股票第二天才能賣出。港股實行',
      text_7: 'T+0回轉交易',
      text_8: '，當天買入的股票可以在當天賣出，並且不限次數，短線盈利空間更大。',
      text_9: '就交收制度而言，A股實行T+1，港股實行T+2，也就是說，如果周一賣出股票，所得資金可以用來買其他股票，但要提取現金就需要等到周三。',
      desc3: '交易單位不同',
      text_10: '港股交易單位也和A股有所差異，A股的一手=100股，而港股的一手可能是100股、500股、1000股，甚至是2000股，',
      text_11: '由上市公司自行決定',
      desc4: '交易品種不同',
      text_12: '港股經過上百年發展，交易品種非常豐富，有很多A股當前還沒有的衍生品，比如',
      text_13: '窩輪、牛熊證、界內證',
      text_14: '等帶有對沖功能的衍生工具。除此之外，港股還支持融資交易，而A股需要50萬資金才能開通融資功能。同時港股支持做空，無論股市漲跌都有賺錢機會。'
    },
    phone1: '更多課堂內容，將陸續推出，敬請期待哦！',
    phone2: '或緻電官方客服 400-688-3187'
  },
  introduction_usa: {
    title: '美股入門',
    title1: '投資全球頂尖公司',
    content1: {
      text_1: '美股',
      text_2: '，即美國股市。美國股票市場是',
      text_3: '規模最大、最開放的市場',
      text_4: '，各種制度完善，上市的公司基本上涵蓋了美國乃至國際上全部著名、知名品牌的產品公司和企業。目前主要由道瓊斯工業股票指數、納斯達克指數和標準普爾500指數三大股指構成。'
    },
    title2: '美股交易市場',
    content2: {
      desc1: '紐約證券交易所',
      text_1: '紐約證券交易所是',
      text_2: '上市公司總市值第一，IPO數量及市值第一，交易量第二的交易所',
      text_3: '。至今已有二百多年歷史，上市企業逾三仟多家，其市場較成熟，上市要求較為嚴格。NYSE上市的主要是商業股，例如：美國商業銀行 BAC。',
      desc2: '納斯達克證券市場',
      text_4: '是一個基於電子網絡的無形市場，是',
      text_5: '美國上市公司最多、股份交易量最大的證券市場',
      text_6: '。掛牌交易的公司已經近七仟家，在此掛牌的公司多半是科技股。',
      desc3: '美國證券交易所',
      text_7: '現為美國第三大股票交易所，是',
      text_8: '唯一一家能同時進行股票、期權和衍生產品交易的交易所',
      text_9: '，也是唯一一家關註於易被人忽略的中小市值公司並為其提供一系列服務來增加其關註度的交易所。'
    },
    title3: '美股的三個主要指數',
    content3: {
      desc1: '道瓊斯工業平均指數',
      text_1: '道瓊斯指數是世界上歷史最為悠久的股票指數，綜合指數是由',
      text_2: '工業、交通運輸、公共事業三個指數的65只成份股組成的平均指數',
      desc2: '納斯達克指數',
      text_3: '納斯達克綜合指數是',
      text_4: '反映納斯達克證券市場行情變化的股票價格平均指數',
      text_5: '，基本指數為100。',
      desc3: '標準普爾500指數',
      text_6: '由知名的評級公司標準普爾，根據市值及流通量，',
      text_7: '在美國股票市場內挑選出500家企業所組成的，以市值加權的股價指數',
      text_8: '。由於其成分股更多元化，能反映美股的價值。',
    },
    title4: '美股衍生品',
    content4: {
      desc1: '期權',
      text_1: '期權，是一種',
      text_2: '選擇權',
      text_3: '，指一種能在未來某特定時間以特定價格買入或賣出一定數量的某種特定商品的權利',
      text_4: '。它是在期貨基礎上產生的一種金融工具，給予買方(或持有者)購買或出售標的資產的權利。',
      desc2: 'ADR',
      text_5: '美國',
      text_6: '存托憑證代錶持有非美國公司股票',
      text_7: '的一種憑證，但投資者可在美股市場上交易。',
      desc3: 'ETF',
      text_8: 'ETF是一種',
      text_9: '跟蹤市場指數、可以在證券交易所自由買賣的開放式股票基金',
      text_10: '。大家可以把ETF理解為一種特殊形式的共同基金：發行機構把不同的股票買來，匯合到一起形成共同基金，然後再分成一小塊一小塊拿到股市上賣，它們就成了可以自由買賣的ETF指數基金。妳買一支ETF就相當於購買了這個指數的所有成份股。',
    },
    phone1: '更多課堂內容，將陸續推出，敬請期待哦！',
    phone2: '或緻電官方客服 400-688-3187'
  },
  introduction_cn: {
    title: '中華通介紹',
    title1: '中華通是什發現有潜力的成長性企業麽',
    content1: {
      text_1: '滬港通與深港通統稱“中華通”',
      text_2: '，是一項互聯互通機制，香港和國際投資者可以通過香港聯合交易所有限公司(以下簡稱“香港聯交所”)及其清算所交易並清算上海證券交易所(以下簡稱“上交所”)和深圳證券交易所(以下簡稱“深交所”)的上市股票。',
      text_3: '上交所/深交所有不同類型的掛牌證券，但滬港通和深港通目前階段只能交易A股(在中國證券交易所交易的大陸公司股票)。',
      text_4: '滬股通',
      text_5: '股票包括所有上證180指數與上證380指數的成分股，以及不在上述指數成份股內但有H股同時在聯交所上市及買賣的上交所A股。',
      text_6: '深港通',
      text_7: '股票包括深證成份指數和深證中小創新指數成份股中所有市值不少於60億元人民幣的成份股，以及有相關H股在聯交所上市的所有深交所上市A股。'
    },
    title2: '中華通北嚮交易特性',
    content2: {
      desc1: '滬港通',
      text_1: '·上證180指數及上證380指數成份股',
      text_2: '· A+H掛牌之A股',
      text_3: '·不包括不以人民幣交易的滬股',
      text_4: '·不包括被實施風險警示的滬股',
      desc2: '深港通',
      text_5: '·深證成份指數及深證中小創新指數成分股',
      text_6: '·市值60億元人民幣以上的深證成分指數及深證中小創新指數成分股',
      text_7: '·A+H掛牌之A股',
      text_8: '·不包括不以人民幣交易的深股',
      text_9: '·不包括被實施風險警示的深股'
    },
    phone1: '更多課堂內容，將陸續推出，敬請期待哦！',
    phone2: '或緻電官方客服 400-688-3187'
  },
  account_manager: {
    title: '我的客戶經理',
    txt_1: '您好，我是您的',
    txt_2: '專屬客戶經理',
    txt_3: '{petName} {name}，請添加我的企業微信，享受至尊VIP服務',
    txt_4: '微信掃碼添加',
    txt_5: '©2023 元宇證券有限公司版權所有',
    qr_txt_1: '複製成功',
    qr_txt_2: '該瀏覽器不支持，請手動複製',
  }
}